import React from 'react';
import PropTypes from 'prop-types';

//MUI
import Box from '@mui/material/Box';
/*import Grid from '@mui/material/Grid';*/

//BIKENTA
import IndicatorInterventionNumber from './IndicatorInterventionNumber';
/*import TotalIndicator from './TotalIndicator';*/

//UTILS
import {CATEGORY_GROUPS} from '../../config';

//STYLE
const getStyle = (id) => CATEGORY_GROUPS.find(cat => cat.id === id);

const InterventionNumberGroup = ({data}) => {
  return <Box sx={{display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2}}>
    {
      data.categoryGroups.map(group => <IndicatorInterventionNumber
        key={group.id}
        label={group.label}
        style={getStyle(group.id)}
        sublabels={group.categories}
      />
      )
    }
  </Box>;
};

InterventionNumberGroup.propTypes = {
  data: PropTypes.shape({
    total: PropTypes.shape({
      executed_interventions: PropTypes.number,
      planned_interventions: PropTypes.number
    }),
    categoryGroups: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      categories: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        planned_interventions: PropTypes.number.isRequired,
        executed_interventions: PropTypes.number.isRequired
      }))
    }))
  })
};

export default InterventionNumberGroup;